import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollUpButton from './components/ScrollUpButton';
import PageTransition from './components/PageTransition';
import Home from './pages/Home';
import KolorsOfKutch from './pages/KolorsOfKutch';
import ThreadsOfTravancore from './pages/ThreadsOfTravancore';
import ThreadsOfTravancoreShop from './pages/ThreadsOfTravancoreShop';
import ShopMen from './pages/ShopMen';
import ShopWomen from './pages/ShopWomen';
import Community from './pages/Community';
import Sustainability from './pages/Sustainability';
import Contact from './pages/Contact';
import FAQs from './pages/FAQs';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ProductDetail from './pages/ProductDetail';
import Profile from './pages/Profile';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderDetails from './pages/OrderDetails';
import PolicyPage from './pages/PolicyPage';
import AdminDashboard from './admin/AdminDashboard';
import ProtectedAdminRoute from './admin/ProtectedAdminRoute';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import './context/Toast.css';
import ShopCollections from './pages/ShopCollections';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import Community2 from './pages/Community2'

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <PageTransition>
      <div className="App">
        <ScrollToTop />
        {!isAdminRoute && <Header />}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections" element={<KolorsOfKutch />} />
            <Route path="/collections/kolors-of-kutch" element={<KolorsOfKutch />} />
            <Route path="/collections/threads-of-travancore" element={<ThreadsOfTravancore />} />
            <Route path="/collections/threads-of-travancore/shop" element={<ThreadsOfTravancoreShop />} />
            <Route path="/shop/mens-wear" element={<ShopMen />} />
            <Route path="/shop/womens-wear" element={<ShopWomen />} />
            <Route path="/community" element={<Community />} />
            <Route path="/community2" element={<Community2 />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/product/:productSlug" element={<ProductDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/orders/:id" element={<OrderDetails />} />
            <Route path="/exchange-policy" element={<PolicyPage />} />
            <Route path="/refund-policy" element={<PolicyPage />} />
            <Route path="/cancellation-policy" element={<PolicyPage />} />
            <Route path="/shipping-policy" element={<PolicyPage />} />
            <Route path="/privacy-policy" element={<PolicyPage />} />
            <Route path="/copyright-policy" element={<PolicyPage />} />
            <Route path="/resale-policy" element={<PolicyPage />} />
            <Route path="/shop-collections" element={<ShopCollections />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/failed" element={<PaymentFailure />} />

            <Route
              path="/admin/dashboard"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />
          </Routes>
        </main>
        {!isAdminRoute && <Footer />}
        <ScrollUpButton />
      </div>
    </PageTransition>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider>
          <AppContent />
        </ToastProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;